const TOKEN_KEY = 'aigc_token';
const ACCOUNT_KEY = 'aigc_account';
const ROLE_KEY = 'aigc_role';

export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

export function setToken(token: string): void {
  localStorage.setItem(TOKEN_KEY, token);
}

export function getAccount(): string | null {
  return localStorage.getItem(ACCOUNT_KEY);
}

export function setAccount(account: string): void {
  localStorage.setItem(ACCOUNT_KEY, account);
}

export function getRole(): string | null {
  return localStorage.getItem(ROLE_KEY);
}

export function setRole(role: string): void {
  localStorage.setItem(ROLE_KEY, role);
}

export function clearAuth(): void {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(ACCOUNT_KEY);
  localStorage.removeItem(ROLE_KEY);
}

export function isLoggedIn(): boolean {
  return !!getToken();
}

export async function loginApi(account: string, password: string): Promise<{ token: string; account: string; role: string }> {
  const { post } = await import('./http');
  return post('/api/auth/login', { account, password });
}

export async function registerApi(account: string, password: string): Promise<{ account: string }> {
  const { post } = await import('./http');
  return post('/api/auth/register', { account, password });
}

export async function resetPasswordApi(account: string, password: string, verifyCode: string): Promise<boolean> {
  const { post } = await import('./http');
  return post('/api/auth/reset-password', { account, password, verifyCode });
}
